/*! @azure/msal-common v15.2.1 2025-03-11 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.2.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
